(() => {
  const getTabs = (root) => Array.from(root.querySelectorAll('[data-shop-by-style-tab]'));

  const activatePanels = (root, index) => {
    root.querySelectorAll('[data-shop-by-style-panel]').forEach((panel) => {
      const on = panel.dataset.shopByStylePanel === String(index);
      panel.classList.toggle('is-active', on);
      if (on) {
        panel.removeAttribute('hidden');
        if (window.DisplayGroupSwatches && typeof window.DisplayGroupSwatches.register === 'function') {
          window.DisplayGroupSwatches.register(panel);
        }
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  };

  const activateTabs = (root, index) => {
    getTabs(root).forEach((tab) => {
      const on = tab.dataset.shopByStyleTab === String(index);
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
  };

  const syncSubheading = (root, index) => {
    const active = root.querySelector(`[data-shop-by-style-tab="${index}"]`);
    const subheading = root.querySelector('[data-shop-by-style-subheading]');
    if (!active || !subheading) return;
    const tagline = active.dataset.tagline;
    subheading.textContent = tagline && tagline.length ? tagline : subheading.dataset.default;
  };

  const activate = (root, index) => {
    activateTabs(root, index);
    activatePanels(root, index);
    syncSubheading(root, index);
  };

  const nextIndex = (key, current, count) => {
    if (key === 'ArrowRight' || key === 'ArrowDown') return (current + 1) % count;
    if (key === 'ArrowLeft' || key === 'ArrowUp') return (current - 1 + count) % count;
    if (key === 'Home') return 0;
    if (key === 'End') return count - 1;
    return -1;
  };

  const handleKeydown = (root, event) => {
    const tab = event.target.closest('[data-shop-by-style-tab]');
    if (!tab || !root.contains(tab)) return;
    const tabs = getTabs(root);
    const target = nextIndex(event.key, tabs.indexOf(tab), tabs.length);
    if (target < 0) return;
    event.preventDefault();
    const index = tabs[target].dataset.shopByStyleTab;
    activate(root, index);
    tabs[target].focus();
  };

  const init = (root) => {
    if (root.dataset.shopByStyleReady) return;
    root.dataset.shopByStyleReady = 'true';
    root.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-shop-by-style-tab]');
      if (!tab || !root.contains(tab)) return;
      activate(root, tab.dataset.shopByStyleTab);
    });
    root.addEventListener('keydown', (event) => handleKeydown(root, event));
  };

  const boot = () => document.querySelectorAll('.shop-by-style').forEach(init);

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // Theme editor: a settings change re-renders the section (new, uninitialised DOM), and
  // selecting a Tab block in the sidebar should show that tab's panel.
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.shop-by-style').forEach(init);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const tab = event.target.closest && event.target.closest('[data-shop-by-style-tab]');
    const root = tab && tab.closest('.shop-by-style');
    if (!root) return;
    init(root);
    activate(root, tab.dataset.shopByStyleTab);
  });
})();
